import store from "@/store/index.js";

export var paxMapper = (paxes, EFltPaxType) => {
   const mapper = {};
   paxes.map((pax) => {
      mapper[pax.id] = {
         paxId: pax.id,
         paxIndex: pax.index,
         paxName: `${pax.name} ${pax.surname}`,
         paxType: EFltPaxType(pax.paxType),
         paxTypeEnum: pax.paxType,
         price: null,
         seat: null,
         cabinType: null,
         selected: false,
         initialSeat: false,
      };
   });
   return mapper;
};

export var paxIdsMapper = (paxes) => {
   const mapper = [];
   paxes.map((pax) => {
      if (pax.parentIndex == 0) {
         mapper.push(pax.id);
      } else {
         store.commit("seatmap/setHasInfant", pax);
      }
   });
   return mapper;
};

export var segmentIdForPaxes = (paxes, segmentId) => {
   return Object.keys(paxes).reduce((acc, key) => {
      acc[key] = {
         ...paxes[key],
         segmentId: segmentId,
         status: true,
      };
      return acc;
   }, {});
};

export var segments = (flights) => {
   const mapper = [];

   Object.keys(flights).forEach((flightKey) => {
      const segments = flights[flightKey].segments;

      Object.keys(segments).forEach((key) => {
         const segment = segments[key];
         mapper.push({
            name: segment.departureAirport + " - " + segment.arrivalAirport,
            index: segment.id,
            status: false,
            departureTime: segment.departureDateTime,
         });
      });
   });

   return mapper;
};

export var seatMapGenerator2 = (rows, segmentId) => {
   // Mapping for status from modelFromApi to myModel
   const statusMap = {
      0: "unavailable",
      1: "available",
      2: "occupied",
   };

   // Function to convert price from EUR to USD (example conversion rate)
   const convertPriceToUSD = (priceInEUR) => {
      const conversionRate = 1.1; // Example conversion rate
      return (priceInEUR * conversionRate).toFixed(2);
   };

   // Function to map seats from modelFromApi to myModel
   const mapSeats = (apiSeats) => {
      return apiSeats.map((seat) => ({
         name: seat.identifier.split("-")[1], // e.g., "OfferFR-1A" -> "1A"
         column: seat.column,
         type: "BUS",
         status: statusMap[seat.status],
         price: convertPriceToUSD(seat.price),
         features: [], // Populate this based on your logic
         exitSeat: false, // Assuming none of the seats are exit seats
         segmentId: segmentId,
      }));
   };

   // Function to convert modelFromApi to myModel
   const convertModel = (apiModels) => {
      return apiModels.map((apiModel) => {
         const seats = mapSeats(apiModel.seats);

         // Splitting seats into groups of 3 for the example (customize as needed)
         const seatGroups = [];
         for (let i = 0; i < seats.length; i += 3) {
            seatGroups.push({
               seats: seats.slice(i, i + 3),
            });
         }

         return {
            rowNumber: apiModel.number,
            class: "Business",
            isExitRow: false,
            seatGroups: seatGroups,
         };
      });
   };

   return convertModel(rows);
};

export const seatMapGenerator = (rows, segmentId) => {
   // Constant flightType for seat configuration
   const flightType = [3, 3];

   // Mapping for status from modelFromApi to myModel
   const statusMap = {
      0: "unavailable",
      1: "available",
      2: "occupied",
   };

   // Generate seat pattern from A to Z
   const generateSeatPattern = () => {
      const seatPattern = [];
      for (let i = 65; i <= 90; i++) {
         seatPattern.push(String.fromCharCode(i));
      }
      return seatPattern;
   };

   const seatPattern = generateSeatPattern();

   // Function to map seats from modelFromApi to myModel
   const mapSeats = (apiSeats, rowNumber, totalRow) => {
      const totalSeats = flightType.reduce((acc, val) => acc + val, 0);

      return seatPattern.slice(0, totalSeats).map((column) => {
         const seat = apiSeats.find((s) => s.column === column);

         if (seat) {
            return {
               name: seat.identifier.split("-")[1],
               identifier: seat.identifier,
               column: seat.column,
               type: seat.applicableTypes,
               status: statusMap[seat.status],
               price: seat.price,
               features: [], // Populate this based on your logic
               exitSeat: seat.description == "Exit seat" ? true : false,
               segmentId: segmentId,
               tooltipLocation: totalRow - rowNumber < 3 ? "up" : "down",
            };
         } else {
            return {
               name: "EMPTY",
               column: column,
               type: "BUS",
               status: "available",
               price: null,
               features: [],
               exitSeat: false,
               segmentId: segmentId,
            };
         }
      });
   };

   // Function to convert modelFromApi to myModel
   const convertModel = (apiModels) => {
      return apiModels.map((apiModel) => {
         const seats = mapSeats(apiModel.seats, apiModel.number, apiModels.length);

         // Splitting seats into groups based on flightType
         const seatGroups = [];
         let start = 0;
         for (let groupSize of flightType) {
            seatGroups.push({
               seats: seats.slice(start, start + groupSize),
            });
            start += groupSize;
         }

         function areDescriptionsSame(seats) {
            if (seats.length === 0) return true;
            const firstDescription = seats[0].description;
            for (let i = 1; i < seats.length; i++) {
               if (seats[i].description !== firstDescription) {
                  return false;
               }
            }
            return firstDescription;
         }

         return {
            r: areDescriptionsSame(apiModel.seats),
            rowNumber: apiModel.number,
            class: "Business",
            isExitRow: areDescriptionsSame(apiModel.seats),
            seatGroups: seatGroups,
         };
      });
   };

   return convertModel(rows);
};

export var dummySearchSeat = {
   searchUuid: "a92cf914-1d2b-4c3f-9846-31438ae4d42f",
   segments: [
      {
         id: 27799,
         index: 1,
         flightNumber: "PC2001",
         operatingAirline: "PC",
         departureDateTime: "2024-07-14T07:55:00",
         arrivalDateTime: "2024-07-14T09:15:00",
         departureAirport: "AYT",
         arrivalAirport: "SAW",
         rows: [
            {
               identifier: "Row1",
               number: 1,
               seats: [
                  {
                     identifier: "OfferFR-1A",
                     column: "A",
                     description: "First row",
                     status: 0,
                     applicableTypes: [2],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1B",
                     column: "B",
                     description: "First row",
                     status: 0,
                     applicableTypes: [3],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1C",
                     column: "C",
                     description: "First row",
                     status: 1,
                     applicableTypes: [1],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1D",
                     column: "D",
                     description: "First row",
                     status: 1,
                     applicableTypes: [1],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1E",
                     column: "E",
                     description: "First row",
                     status: 0,
                     applicableTypes: [3],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1F",
                     column: "F",
                     description: "First row",
                     status: 0,
                     applicableTypes: [2],
                     price: 6,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row2",
               number: 2,
               seats: [
                  {
                     identifier: "OfferPR-2A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row3",
               number: 3,
               seats: [
                  {
                     identifier: "OfferPR-3A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row4",
               number: 4,
               seats: [
                  {
                     identifier: "OfferPR-4A",
                     column: "A",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4B",
                     column: "B",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4C",
                     column: "C",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row5",
               number: 5,
               seats: [
                  {
                     identifier: "OfferPR-5A",
                     column: "A",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5B",
                     column: "B",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5C",
                     column: "C",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row6",
               number: 6,
               seats: [
                  {
                     identifier: "OfferPR-6A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row7",
               number: 7,
               seats: [
                  {
                     identifier: "OfferPR-7A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row8",
               number: 8,
               seats: [
                  {
                     identifier: "OfferPR2-8A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row9",
               number: 9,
               seats: [
                  {
                     identifier: "OfferPR2-9A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row10",
               number: 10,
               seats: [
                  {
                     identifier: "OfferPR2-10A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row11",
               number: 11,
               seats: [
                  {
                     identifier: "OfferPR2-11A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row12",
               number: 12,
               seats: [
                  {
                     identifier: "OfferPR2-12A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row13",
               number: 13,
               seats: [
                  {
                     identifier: "OfferPR2-13A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row14",
               number: 14,
               seats: [
                  {
                     identifier: "OfferPR2-14A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row15",
               number: 15,
               seats: [
                  {
                     identifier: "OfferPR2-15A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row16",
               number: 16,
               seats: [
                  {
                     identifier: "OfferPR2-16A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row17",
               number: 17,
               seats: [
                  {
                     identifier: "OfferPR2-17A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row18",
               number: 18,
               seats: [
                  {
                     identifier: "OfferEX-18A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row19",
               number: 19,
               seats: [
                  {
                     identifier: "OfferEX-19A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row20",
               number: 20,
               seats: [
                  {
                     identifier: "OfferWN-20A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-20F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row21",
               number: 21,
               seats: [
                  {
                     identifier: "OfferWN-21A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-21F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row22",
               number: 22,
               seats: [
                  {
                     identifier: "OfferWN-22A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-22B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-22C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-22D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-22E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-22F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row23",
               number: 23,
               seats: [
                  {
                     identifier: "OfferWN-23A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-23B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-23C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-23D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-23E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-23F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row24",
               number: 24,
               seats: [
                  {
                     identifier: "OfferWN-24A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-24B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-24C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-24D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-24E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-24F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row25",
               number: 25,
               seats: [
                  {
                     identifier: "OfferWN-25A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-25B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-25C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-25D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-25E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-25F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row26",
               number: 26,
               seats: [
                  {
                     identifier: "OfferWN-26A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-26B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-26C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-26D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-26E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-26F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row27",
               number: 27,
               seats: [
                  {
                     identifier: "OfferWN-27A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-27B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-27C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-27D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-27E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-27F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row28",
               number: 28,
               seats: [
                  {
                     identifier: "OfferWN-28A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-28B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-28C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-28D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-28E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row29",
               number: 29,
               seats: [
                  {
                     identifier: "OfferEX-29A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row30",
               number: 30,
               seats: [
                  {
                     identifier: "OfferWN-30A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-30B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-30C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-30D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-30E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-30F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row31",
               number: 31,
               seats: [
                  {
                     identifier: "OfferWN-31A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-31B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-31C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-31D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-31E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-31F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row32",
               number: 32,
               seats: [
                  {
                     identifier: "OfferWN-32A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-32B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-32C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-32D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-32E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-32F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row33",
               number: 33,
               seats: [
                  {
                     identifier: "OfferWN-33A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-33B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-33C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-33D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-33E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-33F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row34",
               number: 34,
               seats: [
                  {
                     identifier: "OfferWN-34A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-34B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-34C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-34D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-34E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-34F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row35",
               number: 35,
               seats: [
                  {
                     identifier: "OfferWN-35A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-35B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-35C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-35D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-35E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-35F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row36",
               number: 36,
               seats: [
                  {
                     identifier: "OfferWN-36A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-36B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-36C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-36D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-36E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-36F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row37",
               number: 37,
               seats: [
                  {
                     identifier: "OfferWN-37A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-37B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-37C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-37D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-37E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-37F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row38",
               number: 38,
               seats: [
                  {
                     identifier: "OfferWN-38A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-38B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-38C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-38D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-38E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-38F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row39",
               number: 39,
               seats: [
                  {
                     identifier: "OfferWN-39A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-39B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-39C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-39D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-39E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-39F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row40",
               number: 40,
               seats: [
                  {
                     identifier: "OfferWN-40A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-40B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-40C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-40D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-40E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-40F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
         ],
      },
      {
         id: 27800,
         index: 2,
         flightNumber: "PC1005",
         operatingAirline: "PC",
         departureDateTime: "2024-07-14T17:15:00",
         arrivalDateTime: "2024-07-14T19:40:00",
         departureAirport: "SAW",
         arrivalAirport: "DUS",
         rows: [
            {
               identifier: "Row1",
               number: 1,
               seats: [
                  {
                     identifier: "OfferFR-1A",
                     column: "A",
                     description: "First row",
                     status: 1,
                     applicableTypes: [2],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1B",
                     column: "B",
                     description: "First row",
                     status: 1,
                     applicableTypes: [3],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1C",
                     column: "C",
                     description: "First row",
                     status: 1,
                     applicableTypes: [1],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1D",
                     column: "D",
                     description: "First row",
                     status: 1,
                     applicableTypes: [1],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1E",
                     column: "E",
                     description: "First row",
                     status: 1,
                     applicableTypes: [3],
                     price: 6,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferFR-1F",
                     column: "F",
                     description: "First row",
                     status: 1,
                     applicableTypes: [2],
                     price: 6,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row2",
               number: 2,
               seats: [
                  {
                     identifier: "OfferPR-2A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-2F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row3",
               number: 3,
               seats: [
                  {
                     identifier: "OfferPR-3A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-3F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row4",
               number: 4,
               seats: [
                  {
                     identifier: "OfferPR-4A",
                     column: "A",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4B",
                     column: "B",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4C",
                     column: "C",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-4F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row5",
               number: 5,
               seats: [
                  {
                     identifier: "OfferPR-5A",
                     column: "A",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5B",
                     column: "B",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5C",
                     column: "C",
                     description: "Priority seat",
                     status: 0,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-5F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row6",
               number: 6,
               seats: [
                  {
                     identifier: "OfferPR-6A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-6F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row7",
               number: 7,
               seats: [
                  {
                     identifier: "OfferPR-7A",
                     column: "A",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7B",
                     column: "B",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7C",
                     column: "C",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7D",
                     column: "D",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7E",
                     column: "E",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR-7F",
                     column: "F",
                     description: "Priority seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row8",
               number: 8,
               seats: [
                  {
                     identifier: "OfferPR2-8A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-8F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row9",
               number: 9,
               seats: [
                  {
                     identifier: "OfferPR2-9A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-9F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row10",
               number: 10,
               seats: [
                  {
                     identifier: "OfferPR2-10A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-10F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row11",
               number: 11,
               seats: [
                  {
                     identifier: "OfferPR2-11A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-11F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row12",
               number: 12,
               seats: [
                  {
                     identifier: "OfferPR2-12A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-12F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row13",
               number: 13,
               seats: [
                  {
                     identifier: "OfferPR2-13A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-13F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row14",
               number: 14,
               seats: [
                  {
                     identifier: "OfferPR2-14A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-14F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row15",
               number: 15,
               seats: [
                  {
                     identifier: "OfferPR2-15A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-15F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row16",
               number: 16,
               seats: [
                  {
                     identifier: "OfferPR2-16A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-16F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row17",
               number: 17,
               seats: [
                  {
                     identifier: "OfferPR2-17A",
                     column: "A",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17B",
                     column: "B",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17C",
                     column: "C",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17D",
                     column: "D",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [1],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17E",
                     column: "E",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [3],
                     price: 4,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferPR2-17F",
                     column: "F",
                     description: "UNDEFINED",
                     status: 1,
                     applicableTypes: [2],
                     price: 4,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row18",
               number: 18,
               seats: [
                  {
                     identifier: "OfferEX-18A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-18F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row19",
               number: 19,
               seats: [
                  {
                     identifier: "OfferEX-19A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-19F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row20",
               number: 20,
               seats: [
                  {
                     identifier: "OfferWN-20A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-20F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row21",
               number: 21,
               seats: [
                  {
                     identifier: "OfferWN-21A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-21F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row22",
               number: 22,
               seats: [
                  {
                     identifier: "OfferWN-22A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-22B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-22C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-22D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-22E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-22F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row23",
               number: 23,
               seats: [
                  {
                     identifier: "OfferWN-23A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-23B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-23C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-23D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-23E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-23F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row24",
               number: 24,
               seats: [
                  {
                     identifier: "OfferWN-24A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-24B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-24C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-24D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-24E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-24F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row25",
               number: 25,
               seats: [
                  {
                     identifier: "OfferWN-25A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-25B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-25C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-25D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-25E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-25F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row26",
               number: 26,
               seats: [
                  {
                     identifier: "OfferWN-26A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-26B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-26C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-26D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-26E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-26F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row27",
               number: 27,
               seats: [
                  {
                     identifier: "OfferWN-27A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-27B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-27C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-27D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-27E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-27F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row28",
               number: 28,
               seats: [
                  {
                     identifier: "OfferWN-28A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-28B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-28C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-28D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-28E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row29",
               number: 29,
               seats: [
                  {
                     identifier: "OfferEX-29A",
                     column: "A",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29B",
                     column: "B",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29C",
                     column: "C",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29D",
                     column: "D",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [1, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29E",
                     column: "E",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [3, 4],
                     price: 5,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferEX-29F",
                     column: "F",
                     description: "Exit seat",
                     status: 1,
                     applicableTypes: [4, 2],
                     price: 5,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row30",
               number: 30,
               seats: [
                  {
                     identifier: "OfferWN-30A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-30B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-30C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-30D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-30E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-30F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row31",
               number: 31,
               seats: [
                  {
                     identifier: "OfferWN-31A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-31B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-31C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-31D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-31E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-31F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row32",
               number: 32,
               seats: [
                  {
                     identifier: "OfferWN-32A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-32B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-32C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-32D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-32E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-32F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row33",
               number: 33,
               seats: [
                  {
                     identifier: "OfferWN-33A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-33B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-33C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-33D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-33E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-33F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row34",
               number: 34,
               seats: [
                  {
                     identifier: "OfferWN-34A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-34B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-34C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-34D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-34E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-34F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row35",
               number: 35,
               seats: [
                  {
                     identifier: "OfferWN-35A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-35B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-35C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-35D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-35E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-35F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row36",
               number: 36,
               seats: [
                  {
                     identifier: "OfferWN-36A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-36B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-36C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-36D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-36E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-36F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row37",
               number: 37,
               seats: [
                  {
                     identifier: "OfferWN-37A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-37B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-37C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-37D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-37E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-37F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row38",
               number: 38,
               seats: [
                  {
                     identifier: "OfferWN-38A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-38B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-38C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-38D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-38E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-38F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row39",
               number: 39,
               seats: [
                  {
                     identifier: "OfferWN-39A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-39B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-39C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-39D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-39E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-39F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
            {
               identifier: "Row40",
               number: 40,
               seats: [
                  {
                     identifier: "OfferWN-40A",
                     column: "A",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-40B",
                     column: "B",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-40C",
                     column: "C",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferAS-40D",
                     column: "D",
                     description: "Aisle side seat",
                     status: 1,
                     applicableTypes: [1],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferMD-40E",
                     column: "E",
                     description: "Middle seat",
                     status: 1,
                     applicableTypes: [3],
                     price: 3,
                     currency: "EUR",
                  },
                  {
                     identifier: "OfferWN-40F",
                     column: "F",
                     description: "Window side seat",
                     status: 1,
                     applicableTypes: [2],
                     price: 3,
                     currency: "EUR",
                  },
               ],
            },
         ],
      },
   ],
   uuid: null,
   result: {
      success: true,
      app: "",
      service: "",
      code: "SUCCESS",
      subCode: "OK",
      message: "",
   },
   id: 0,
   ids: [],
};
